import React from 'react';

import { AppSidebar } from '../components/AppSidebar';
import { AppTopBar } from '../components/AppTopBar';
import { DashboardContent } from '../features/dashboard/DashboardContent';
import { OfferDashboardContent } from '../features/dashboard/OfferDashboardContent';
import { DashboardLoadingSkeleton } from '../features/dashboard/components/DashboardLoadingSkeleton';
import { useModuleAccess } from '../hooks/useModuleAccess';
import { resolveWorkspaceProfile } from '../lib/workspaceProfile';

export function DashboardPage() {
  const { loaded, modules } = useModuleAccess();
  // Erst entscheiden, wenn die Module der Instanz da sind, sonst blitzt die falsche Übersicht auf.
  const profile = loaded ? resolveWorkspaceProfile(modules) : null;

  return (
    <div className="h-screen min-h-0 flex overflow-hidden bg-app-surface-muted text-app-text">
      <AppSidebar active="dashboard" />
      <div className="flex-1 min-w-0 min-h-0 flex flex-col overflow-hidden">
        <AppTopBar title="Übersicht" />
        <main className="app-scrollbar flex-1 min-h-0 overflow-y-auto overscroll-contain p-5 pb-20 md:pb-5">
          {profile === null ? (
            <DashboardLoadingSkeleton />
          ) : profile === 'angebote' ? (
            <OfferDashboardContent />
          ) : (
            <DashboardContent />
          )}
        </main>
      </div>
    </div>
  );
}
